import { render, staticRenderFns } from "./DashboardCardFaultsPieChart.vue?vue&type=template&id=5650a942"
import script from "./DashboardCardFaultsPieChart.vue?vue&type=script&lang=ts"
export * from "./DashboardCardFaultsPieChart.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCardFaultsPieChart.vue?vue&type=style&index=0&id=5650a942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports